<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-data-table
      ref="table1"
      :headers="headers"
      :items="seminars"
      :expanded.sync="expandedList"
      :loading="loading"
      show-expand
      class="elevation-2 parent-table"
      :hide-default-footer="true"
      @click:row="onRowClick"
    >
      <template #expanded-item="{ item: seminar }">
        <td
          :colspan="headers.length"
          class="px-0"
        >
          <v-data-table
            :items="seminar.employees"
            :hide-default-footer="true"
            :items-per-page="-1"
            disable-pagination
            class="elevation-0"
            :no-data-text="$t('course_report.no_employee_text')"
            :dense="seminar.employees?.length > 0"
          >
            <template #item="{ item: employee }">
              <seminar-list-row
                :employee="employee"
                :seminar="seminar"
                :disabled="softLoading || !assertEmployeeEligibleForReminder(employee, { allowSubmissionFlag: seminar.report })"
                :column-widths="tableWidth.map(width => (width ? `${width}px` : '0px'))"
              />
            </template>
          </v-data-table>
        </td>
      </template>
      <template #[`item.data-table-expand`]="{ item: seminar }">
        <v-icon
          :key="seminar.id"
          color="primary"
          size="small"
          class="v-data-table__expand-icon v-icon--link mdi mdi-triangle theme--light icon-90"
        />
      </template>
      <template #[`item.mail`]="{ item: seminar }">
        <bulk-send-email-button
          :disabled="softLoading || !seminar.report"
          :seminar="seminar"
        />
      </template>
      <template #[`item.report`]="{ item: seminar }">
        <seminar-submission-toggle-button :seminar="seminar" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from 'moment-timezone'
import SeminarListRow from './SeminarListRow'
import BulkSendEmailButton from './BulkSendEmailButton'
import SeminarSubmissionToggleButton from './SeminarSubmissionToggleButton'

export default {
  components: {SeminarSubmissionToggleButton, BulkSendEmailButton, SeminarListRow},
  props: {
    headers: {
      required: true,
      type: Array
    },
    seminars: {
      required: true,
      type: Array
    },
    loading: {
      required: true,
      type: Boolean
    },
    softLoading: {
      required: true,
      type: Boolean
    }
  },

  data() {
    return {
      expandedList: [],
      tableWidth: []
    }
  },

  mounted() {
    window.addEventListener('resize', this.syncColumnWidths)
    if (this.$vuetify.breakpoint.xs) {
      this.syncColumnWidths()
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.syncColumnWidths)
  },

  methods: {
    syncColumnWidths() {
      const reference = this.$vuetify.breakpoint.smAndUp ? 'th' : 'tbody'
      const table1Headers = this.$refs.table1.$el.querySelectorAll(reference)
      const widths = []
      table1Headers.forEach(header => {
        widths.push(header.offsetWidth)
      })
      this.tableWidth = widths
    },

    onRowClick(item, event) {
      if (event.isExpanded) {
        const index = this.expandedList.findIndex(i => i === item)
        this.expandedList.splice(index, 1)
      } else {
        this.expandedList = [item]
      }
      this.syncColumnWidths()
    },

    assertEmployeeEligibleForReminder(employee, {allowSubmissionFlag}) {
      const today = moment()
      const seminarStartDate = moment.tz(employee.start_date, 'Asia/Tokyo')

      const isEligibleForPre = today < seminarStartDate && !employee.pre
      const isEligibleForPost = today >= seminarStartDate && !employee.post

      return (isEligibleForPost || isEligibleForPre) && allowSubmissionFlag
    },
  }
}
</script>

<style scoped>
::v-deep .v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
  background-color: rgba(238, 238, 238, 0.70);
}
.icon-90 {
  transform: rotate(90deg);
}
.v-data-table__expanded.v-data-table__expanded__row i {
  transform: rotate(180deg);
}
</style>
